import {
    OptionPreviousApprovalHistoryDto,
    ResourceListOfWorkflowOptionApprovalDto,
    WorkflowOptionApprovalDto
} from "../../services/Client";
import {ActionTypes} from "./ActionTypes";
import {Dispatch} from "react-redux";
import {IReduxState} from "../IReduxState";
import GeneralActions from "./GeneralActions";

const ApprovalViewActions = {
    ReceivedApprovals(data?: ResourceListOfWorkflowOptionApprovalDto) {
        return {type: ActionTypes.RECEIVE_APPROVAL_LIST, data: data};
    },
    UpdateOpenApprovalsCount(payload?: number) {
        return {type: ActionTypes.UPDATE_OPEN_APPROVALS_COUNT, payload};
    },
    GetLastApprovalOptionHistory(
        t: reactI18Next.TranslationFunction,
        approval: WorkflowOptionApprovalDto,
        setMessage: (message: string) => void,
        setResult: (previousApproval: OptionPreviousApprovalHistoryDto) => void
    ) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {

            const loadingScreenMessage = t('BASEOPTIONS:GET_HISTORY');

            setMessage("BASEOPTIONS:GET_HISTORY");
            const {client} = getState().general;

            if (!client.GET_LastApprovalOptionHistory(approval).canExecute()) {
                setMessage("GLOBAL:MISSING_ACCESS_RIGHTS");
            }

            dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

            client.GET_LastApprovalOptionHistory(approval).execute()
                .then((result: OptionPreviousApprovalHistoryDto) => {
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    setMessage("");
                    setResult(result);
                })
                .catch(() => {
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    setMessage("ERRORS:GET_HISTORY_FAIL");
                });
        };
    }
};

export default ApprovalViewActions;



// WEBPACK FOOTER //
// ./src/redux/actions/ApprovalViewActions.tsx